export default __webpack_public_path__ + "static/media/money-sign-circle__icon.6b647ff8.svg";